export const queryKeys = {
  workers: {
    all: ["workers"] as const,
    detail: (id: string) => ["workers", id] as const,
    conversations: (id: string) => ["workers", id, "conversations"] as const,
    conversation: (workerId: string, convId: string) =>
      ["workers", workerId, "conversations", convId] as const,
    health: (id: string) => ["workers", id, "health"] as const,
    checkEmail: (login: string) => ["workers", "check-email", login] as const,
  },
  credits: {
    balance: ["credits", "balance"] as const,
    transactions: ["credits", "transactions"] as const,
  },
  settings: ["settings"] as const,
  config: {
    runtimes: ["config", "runtimes"] as const,
  },
};
